import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const tablesSlice = createSlice({
  name: 'tables',
  initialState,
  reducers: {
    set(_, action) {
      return action.payload;
    },
    setFavorite() { /* do nothing */ }, // Action used to trigger an ADD/REMOVE favorite
    updateTable(state, action) {
      action.payload.forEach(({ tableId, ...fields }) => {
        state[tableId] = {
          ...state[tableId],
          ...fields,
        };
      });
    },
    updateFavorite(state, action) {
      const { tableId, favorite } = action.payload;
      state[tableId].favorite = favorite;
    },
    failure() { /* do nothing */ },
  },
});

export const tables = tablesSlice.actions;
export default tablesSlice.reducer;
